import React from "react";

export default function LoginInputField({
  placeholder,
  label,
  icon,
  type,
  value,
  onChange,
  onBlur,
  id,
  required,
  name,
}) {
  return (
    <div className="login-form-field">
      <label className="sr-only" htmlFor="login-field">
        {label}
      </label>
      <div className="input-group mb-2 mr-sm-2">
        <div className="input-group-prepend">
          {/* <div className="input-group-text">
            <i className={`fa fa-${icon}`}></i>
          </div> */}
        </div>
        <input
          type={type}
          className="my-select"
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          name={name}
        />
      </div>
    </div>
  );
}
